export default "__VITE_ASSET__aLBabIP3__"